
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getFunctions } from "firebase/functions";

const firebaseConfig = {
  apiKey: "AIzaSyBat6To0GxEmv9BpT55fn3zibRlBLY3F-4",
  authDomain: "cineastefilm.org",
  projectId: "cineaste-438e5",
  storageBucket: "cineaste-438e5.firebasestorage.app",
  messagingSenderId: "669050257485",
  appId: "1:669050257485:web:c5ca83726a375018d5dc04",
  measurementId: "G-EL1ZV3F12R"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
export const functions = getFunctions(app, "us-central1");
